import {createPluginFromSingleComponentPlugin} from '../../pluginsFactory'
import {pack} from './pack'

export const typesPlugin = createPluginFromSingleComponentPlugin({
    name: 'TypesPlugin',
    pack
})
